import { BoxIndicator } from '@classtinginc/design-system';
import loadable from '@loadable/component';

const SignUpAdminPage = loadable(() => import('./SignUpAdminPage'), {
  fallback: <BoxIndicator />,
});

export default SignUpAdminPage;
